<script setup lang="ts">
import type { ProductsProps } from "./Products.props"

defineProps<ProductsProps>()
const route = useRoute()

const emit =
  defineEmits<{
    (e: "onAddToCart", productName: string): void
    (e: "onClickShowResult"): void
    (e: "onCloseModal"): void
  }>()

const clickShowResult = () => emit("onClickShowResult")

const handleAddToCartNotification = (productName: string) => {
  emit("onAddToCart", productName)
}

const handleCloseModal = (event) => {
  if (event.path === route.path) emit("onCloseModal")
}

const searchInput = useState("searchbar-query-state")
</script>

<template>
  <div class="search-products">
    <div class="beaver mb-6 flex items-center gap-1" v-if="suggestion">
      <span>{{ $t("searchbar.maybeYouLookingFor") }}:</span>
      <UtilsMarkdown
        class="
          markdown__link-beaver-medium
          markdown__link-underlined
          markdown__link-green-main
        "
        :content="suggestion"
      />
    </div>

    <div class="relative grid md:grid-cols-8 md:gap-x-3 md:gap-y-3">
      <div
        v-if="moreProducts"
        :class="[
          'order-first flex h-full w-full items-end md:absolute md:h-auto md:justify-end md:pr-4',
          {
            'md:col-span-4 md:col-start-5': !suggestions
          },
          {
            'z-0 md:col-span-3 md:col-start-6': suggestions
          },
          { 'md:-top-[49px]': cards?.length > 1 },
          { 'md:bottom-0': cards?.length == 1 }
        ]"
      >
        <UtilsButton
          class="
            beaver-medium
            [&_span.utils-markdown]:text-center [&_span]:whitespace-normal
          "
          v-bind="moreProducts"
          theme="ghost-green"
          customClasses="p-0 mb-2 md:mb-0 beaver-medium underline"
          order="last"
          @click="clickShowResult"
          stop
        >
          <template #icon
            ><UtilsIcon
              name="ArrowRight.svg"
              color="green-main"
              class="h-5 w-5"
          /></template>
        </UtilsButton>
      </div>
      <div
        class="mt-2 md:col-span-4 md:mt-0"
        v-for="(card, index) in cards"
        :key="card.title"
      >
        <GAListInstantSearchProducts :name="searchInput">
          <GAItem id="search-results" :item="cards" :disable="index != 0">
            <GAViewItemList>
              <ProductTileOverallSearch
                @notification="handleAddToCartNotification(card.title)"
                v-bind="card"
                class="md:h-full"
                is-search-results
                :full-width="false"
                :item-list="`Instant Search: ${searchInput}`"
                @on-close-modal="handleCloseModal"
              />
            </GAViewItemList>
          </GAItem>
        </GAListInstantSearchProducts>
      </div>
    </div>
  </div>
</template>
